import { render } from "./callFollowUpListV2.vue?vue&type=template&id=74f3acde&scoped=true"
import script from "./callFollowUpListV2.vue?vue&type=script&lang=js"
export * from "./callFollowUpListV2.vue?vue&type=script&lang=js"

import "./callFollowUpListV2.vue?vue&type=style&index=0&id=74f3acde&scoped=true&lang=css"

import exportComponent from "/Users/habeebrahman/Documents/htdocs/cdz_projects/wg-frontend-v1/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74f3acde"]])

export default __exports__